import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import {
  Modal, Form, Button, message, Spin,
} from 'antd';
import DocConstant from '../appApply/validate';
import CaseApply from './CaseApply';
import util from '../../../util/index';
import dayjs from 'dayjs';

const {
  getEcId,
} = util;
const createForm = Form.create;
const {
  checkLicense,
} = DocConstant;
const store = ['modeListStore', 'caseListStore'];
@inject(...store)
@observer
class App extends React.Component {

  static defaultProps = {
    prefixCls: "app-apply-modal",
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible || false,
    }
  }
  componentWillReceiveProps(nextProps) {
    const { visible } = this.props;
    if (nextProps.visible !== visible) {
      this.setState({ visible: nextProps.visible });
    }
  }
  onCancel = () => {
    const { onCancel, caseListStore: { initApply }, modeListStore: { isKbStatus, setMobxState }, form } = this.props;
    setMobxState({isKbStatus: true});
    typeof onCancel === 'function' && onCancel();
    form.resetFields();
    initApply();
  }
  onSubmit = () => {
    const { caseListStore: { applyDemo, apply, isPermissions }, form } = this.props;
    form.validateFields((errors, values) => {
      if (!errors) {
        let params = {
          ...toJS(apply),
          authKey: apply.authKey.trim()
        };
        if(isPermissions) {
          const { appId, orderNum, expireDate, authKey } = apply;
          params = {
            appId,
            orderNum,
            expireDate: dayjs(expireDate).format("YYYY-MM-DD"),
            authKey
          }
        }
        applyDemo(params).then(data => data.status && this.onCancel());
      }
    });
  }
  render() {
    const { visible } = this.state;
    const { prefixCls, workflowChart = false, modeListStore: { isKbStatus, formLoading }, caseListStore: { applyDemoLoading, isPermissions } } = this.props;
    const title = workflowChart ? '申请流程' : isPermissions ? "申请开发授权" : '申请应用'
    return (
      <Modal
        title={(<div>{title}</div>)}
        className={prefixCls}
        visible={visible}
        onCancel={this.onCancel}
        maskClosable={false}
        width={600}
        bodyStyle={{ minHeight: 400 }}
        footer={[
          <Button key="submit" loading={applyDemoLoading} type="primary" onClick={() => !applyDemoLoading && this.onSubmit()} disabled={isKbStatus}>提交</Button>,
          <Button key="cancel" onClick={this.onCancel}>返回</Button>
        ]}
      >
        <Spin spinning={formLoading}>
          <CaseApply {...this.props} />
        </Spin>
      </Modal >
    )
  }
}

App = createForm({
  onValuesChange: (props, changed, allValues) => {
    const { onFormChange } = props;
    typeof onFormChange === 'function' && onFormChange(changed, allValues);
  }
})(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/util/caseApply/index.js